module.exports = __webpack_public_path__ + "assets/804261952ac98104f318c7ce8972e79c.jpg";